module.exports = __WEBPACK_EXTERNAL_MODULE_166__;


/*****************
 ** WEBPACK FOOTER
 ** external {"root":"ReactRedux","commonjs":"redux","commonjs2":"redux","amd":"redux"}
 ** module id = 166
 ** module chunks = 0
 **/